<template>
  <div
    class="language-switcher"
    data-testid="language-switcher"
  > 
    <v-select
      v-model="selectedFlag"
      :items="flags"
      data-testid="myselectref"
      attach
      dense
      chips
      class="px-0"
    >
      <template
        v-slot:selection="{ item }"
        mx-auto
      >
        <country-flag
          :country="item"
          size="normal"
        />
      </template>
      <template
        v-slot:item="{ item, attrs, on }"
        style="width: 40px;"
        class="px-0"
      >
        <v-list-item
          class="mx-auto px-0"
          v-bind="attrs"
          v-on="on"
        >
          <country-flag
            :country="item"
            size="normal"
          />
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>


<script>
import CountryFlag from 'vue-country-flag'
import i18n from '../plugins/i18n';

export default {
    components: {
        CountryFlag
    },
    data: () => ({
        language: window.$cookies.get('language') ? window.$cookies.get('language') : window.$cookies.get('space_language') ? window.$cookies.get('space_language') : 'sv',
        selectedFlag: 'gb',
        flags: [
            'gb',
            'se',
            'mk'
        ]
    }),
    watch: {
        selectedFlag(val) {
            this.selectedFlag = val
            this.language = val == 'se' ? 'sv' : val == 'mk' ? 'mk' : 'en'
            i18n.locale = this.language
            window.$cookies.set("language", this.language, 0, null, process.env.VUE_APP_DOMAIN)
            this.$emit('languageSelected')
        }
    },
    async created(){
        this.selectedFlag = this.language == 'sv' ? 'se' : this.language == 'mk' ? 'mk' : 'se'
        i18n.locale = this.language
    }
}
</script>
<style>
.language-switcher {
    width: 52px;

}
.language-switcher .v-list.v-select-list {
    padding: 0;
}
.language-switcher .v-select__selections input,
.language-switcher .v-text-field__details {
    display: none;
}
.language-switcher .v-input__slot,
.language-switcher .v-text-field.v-input--is-focused .v-input__slot {
    border: none !important;
    margin: 0;
}
.language-switcher .v-select > .v-input__control > .v-input__slot {
    margin: 0;
}
.language-switcher .v-input__slot::before,
.language-switcher .v-input__slot::after {
    content: none !important;
}
.language-switcher .v-select__selections .normal-flag,
.language-switcher .v-list.v-select-list .normal-flag{
  margin: 0;
}
@media only screen and (min-width: 960px) {
  .language-switcher {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>
                
